import { SETVI_DEFAULT_IMAGE } from '@setvi/shared/components';
import type { ProductAssetDocument, Resource } from '@setvi/shared/interfaces';
import { GetResourceTypeName } from '@setvi/shared/utils';

/** A product asset shaped like a Setvi resource, so the existing table columns
 *  and mobile card render it exactly as they render associated resources. */
export type ProductAssetRow = Pick<
  Resource,
  'ResourceID' | 'Name' | 'ResourceTypeID' | 'ResourceTypeName' | 'ThumbURL'
> & {
  asset: ProductAssetDocument;
};

export const toResourceRow = (
  asset: ProductAssetDocument
): ProductAssetRow => ({
  ResourceID: asset.id,
  Name: asset.name,
  ResourceTypeID: asset.resourceTypeId,
  // Not every Setvi type has a display name (e.g. 2 = text document, which
  // Bynder uses for fonts and lists), so fall back to the file extension.
  ResourceTypeName: GetResourceTypeName(asset.resourceTypeId) || asset.fileType,
  // The generic placeholder when the API carries no thumbnail, rather than
  // the per-type thumbnail the columns would otherwise fall back to.
  ThumbURL: asset.thumbnailUrl || SETVI_DEFAULT_IMAGE,
  asset
});
